import './index.scss'

import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('ident')

const Ident = ({ children, large, xlarge, symbol, animate, light, guidelines, preloader, ...props }) => {
  const modifiers = {
    large,
    xlarge,
    symbol,
    guidelines,
    animate,
    preloader,
    light,
    ...props,
  }

  return (
    <div {...bem('', modifiers)} {...props}>

      {guidelines &&
        <>
          <div {...bem('guidelines')}></div>
        </>
      }
      <div {...bem('symbol')}>
        {children}
      </div>
      {!symbol &&
        <div {...bem('typo')}>
          <span>Waved</span>
        </div>
      }
    </div>
  )
}

Ident.propTypes = {
  children: PropTypes.any,
  animate: PropTypes.bool,
  preloader: PropTypes.bool,
  large: PropTypes.bool,
  xlarge: PropTypes.bool,
  symbol: PropTypes.bool,
  light: PropTypes.bool,
}

export default Ident
